export const SWITCH_LANG = "SWITCH_LANG";
